import { ResponseTanpokenSettingItem } from '@/repositories/fuzoku-meisai/junsoku/data'
import { Axios } from 'axios'

export interface TanpokenRepository {
  list (): Promise<ResponseTanpokenSettingItem[]>;

  save (param: ResponseTanpokenSettingItem[]): Promise<ResponseTanpokenSettingItem[]>;
}

export class TanpokenRepositoryImpl implements TanpokenRepository {
  constructor (http: Axios, baseUrl: string) {
    this.http = http
    this.baseUrl = `${baseUrl}/tanpoken`
  }

  private readonly http: Axios

  private readonly baseUrl: string

  async list (): Promise<ResponseTanpokenSettingItem[]> {
    const { data } = await this.http.get(this.baseUrl)
    return data
  }

  async save (param: ResponseTanpokenSettingItem[]): Promise<ResponseTanpokenSettingItem[]> {
    const { data } = await this.http.post(this.baseUrl, param)
    return data
  }
}
